<template>
  <div class="max-centred text-center">
    <div v-if="err">
      <strong class="red--text text--lighten-1">
        Some error occurred while linking. Please reach out to the owner of this application.
      </strong>
    </div>
    <div v-else>
      <strong class="green--text text--lighten-1"> Your accounts were successfully linked! </strong>
    </div>
    <v-btn color="primary" class="mt-8" :to="{ name: 'landing-page' }">Main Page</v-btn>
  </div>
</template>

<script>
export default {
  name: 'SuccessOrFailure',
  props: {
    err: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style scoped></style>
